import React from "react";
import styles from "./ButtonWithIcon.module.scss";

const ButtonWithIcon = (props) => {

    const { children } = props;
    const type = props.type || "primary";
    const hasShadow = props.hasShadow || false;
    const disabled = props.disabled || false;
    const onClick = props.onClick || null;

    return (
      <button
        onClick={onClick}
        className={
            [
                styles.ButtonWithIcon,
                styles[type],
                (hasShadow ? styles.shadow : ''),
                (disabled ? styles.disabled : '')
            ].join(' ')
        }
      >
          { children }
      </button>
    )
};

export default ButtonWithIcon;